import { c as _c } from "react-compiler-runtime";
import NextImage, { ImageProps as NextImageProps, StaticImageData } from "next/image";
import { cn } from "@/core/utils/helpers.utils";
export type ImageProps = NextImageProps & {
  src: string | StaticImageData;
  className?: string;
};

/**
 * Thin wrapper over `next/image` that defers to Next.js's built-in optimization
 * pipeline (responsive `srcset`, AVIF/WebP transcoding, on-demand resizing).
 *
 * Pass `priority` for above-the-fold / LCP images.
 *
 * Pass `unoptimized` when:
 *   - the source is an SVG or animated GIF (optimizer can't help),
 *   - the source host is not (and shouldn't be) listed in
 *     `next.config.ts` → `images.remotePatterns`,
 *   - or you're rendering a one-off third-party image and don't want it
 *     proxied through `/_next/image`.
 *
 * Adding a new external image host? Update `images.remotePatterns` in
 * `next.config.ts`; otherwise the optimizer throws
 * `Invalid src prop ... hostname is not configured` at runtime.
 */
export default function Image(props) {
  const $ = _c(10);
  let className;
  let quality;
  let rest;
  if ($[0] !== props) {
    ({
      className,
      quality,
      ...rest
    } = props);
    $[0] = props;
    $[1] = className;
    $[2] = quality;
    $[3] = rest;
  } else {
    className = $[1];
    quality = $[2];
    rest = $[3];
  }
  let t0;
  if ($[4] !== className) {
    t0 = cn(className);
    $[4] = className;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const t1 = quality ?? 90;
  let t2;
  if ($[6] !== rest || $[7] !== t0 || $[8] !== t1) {
    t2 = <NextImage {...rest} className={t0} quality={t1} />;
    $[6] = rest;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}